import { h, Component } from 'preact';
import Store from 'store/store';
import isShallowEqual from 'shallow-equals';
import s from 'components/bolt/videos/player.sss';
import Youtube from 'components/bolt/youtube/youtube';
import Vimeo from 'components/bolt/vimeo/vimeo';
import NativeVideo from 'components/bolt/nativeVideo/nativeVideo';
import Kaltura from 'components/bolt/kaltura/kaltura';
import { joinClasses } from 'utils/utils';

export default class VideoPlayer extends Component {

	constructor(props) {
		super(props);

		this.hideLoader = this.hideLoader.bind(this);
		this.showLoader = this.showLoader.bind(this);
		this.toggleLoader = this.toggleLoader.bind(this);
		this.onReady = this.onReady.bind(this);

		this.disableYoutubeCookieCheck = Store.get().appData?.options?.disableYoutubeCookieCheck;
	}

	shouldComponentUpdate(nextProps) {
		return !isShallowEqual(nextProps.activeVideo, this.props.activeVideo)
			|| this.props.hiddenPlaylist !== nextProps.hiddenPlaylist
			|| !isShallowEqual(nextProps.ageGateProtected, this.props.ageGateProtected);
	}

	componentDidUpdate(prevProps) {
		if (prevProps.activeVideo !== this.props.activeVideo) {
			this.showLoader();
		}

		if (!this.props.ageGateProtected && prevProps.ageGateProtected && !this.props.noAutoplay) {
			this.play();
		}
	}

	play() {
		this.player?.play();
	}
	get duration() {
		return this.player?.duration || 0;
	}

	toggleLoader(show) {
		if (typeof show !== 'boolean') {
			show = !this.state.showLoader;
		}
		this.setState({ showLoader: show });
	}

	showLoader() {
		this.toggleLoader(true);
	}

	hideLoader() {
		this.toggleLoader(false);
	}

	onReady() {
		this.hideLoader();
		if (this.props.onLoaded) {
			this.props.onLoaded();
		}
	}

	render(props) {
		let { activeVideo, onEnded, onStart, onPlay, onPause, overrideStyles, noAutoplay, hiddenPlaylist, isShowtimesMessage, extraClass, isTrailerOverlay, muted, ageGateProtected } = props;
		let { showLoader } = this.state;
		let autoplay = (noAutoplay || activeVideo?.noAutoplay || ageGateProtected) ? false : true;

		activeVideo = activeVideo || {};

		let videoElement;

		if (activeVideo.youtubeId) {
			videoElement = (
				<Youtube
					ref={ref => this.player = ref}
					videoId={activeVideo.youtubeId}
					onEnded={onEnded}
					onStart={onStart}
					onPlay={onPlay}
					onPause={onPause}
					onPlayerReady={this.onReady}
					autoplay={autoplay}
					isShowtimesMessage={isShowtimesMessage}
					noCookies={activeVideo.noCookies && activeVideo.noCookies !== 'Cookie Mode'}
					disableCookieCheck={this.disableYoutubeCookieCheck}
					isTrailerOverlay={isTrailerOverlay}
					isTrailer={activeVideo.isTrailer}
					key={`youtube-${activeVideo.youtubeId}`}
					muted={muted}
				/>
			);
		} else if (activeVideo.vimeoId) {
			videoElement = (
				<Vimeo
					ref={ref => this.player = ref}
					videoId={activeVideo.vimeoId}
					videoHash={activeVideo.vimeoHash}
					autoplay={autoplay}
					onEnded={onEnded}
					onPlayerReady={this.onReady}
					isShowtimesMessage={isShowtimesMessage}
					isTrailerOverlay={isTrailerOverlay}
					isTrailer={activeVideo.isTrailer}
					key={`vimeo-${activeVideo.vimeoId}`}
					muted={muted}
				/>
			);
		} else if (activeVideo.videoSrc) {
			videoElement = (
				<NativeVideo
					ref={ref => this.player = ref}
					activeVideo={activeVideo}
					autoplay={autoplay}
					onEnded={onEnded}
					canPlayCallback={this.onReady}
					isShowtimesMessage={isShowtimesMessage}
					isTrailerOverlay={isTrailerOverlay}
					isTrailer={activeVideo.isTrailer}
					key={`nativeVideo-${activeVideo.videoSrc}`}
					overrideStyles={overrideStyles}
					muted={muted}
				/>
			);
		} else if (activeVideo.disneySrc) {
			videoElement = (
				<Kaltura
					ref={ref => this.player = ref}
					activeVideo={activeVideo}
					autoplay={autoplay}
					isShowtimesMessage={isShowtimesMessage}
					isTrailerOverlay={isTrailerOverlay}
					isTrailer={activeVideo.isTrailer}
					onPlayerReady={this.onReady}
					key={`kaltura-${activeVideo.disneySrc}`}
					muted={muted}
				/>
			);
		}

		return (
			<div class={joinClasses(!overrideStyles && s.container, hiddenPlaylist && s.hiddenPlaylist, extraClass)}>
				<div class={s.keepAspectRatio}>
					<div class={joinClasses(s.loader, showLoader && s.visible)} ref={ref => this.loader = ref}>
						<div class={s.spinner} />
					</div>
					{videoElement}
				</div>
			</div>
		);
	}
}
